import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { CalendarTicket } from "src/app/shared/models/calendar/calendar-ticket.interface";
import { CalendarService } from "src/app/shared/services/calendar.service";
import { environment } from "src/environments/environment";
import { setAPIStatus } from "../apiState.interface";
import { invokeCalendarLaunch, resultCalendarLaunch } from "./calendar.actions";

/** Translated by the global API error handler as `response.error.CALENDAR_LAUNCH_FAILED`. */
export const CALENDAR_LAUNCH_FAILED = "CALENDAR_LAUNCH_FAILED";

@Injectable()
export class CalendarEffect {
  constructor(
    private actions$: Actions,
    private calendarService: CalendarService
  ) {}

  invokeCalendarLaunch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeCalendarLaunch),
      exhaustMap(() => {
        const calendarTab = window.open("about:blank", "_blank");
        if (!calendarTab) {
          return of(resultCalendarLaunch(), this.launchFailed(null));
        }
        calendarTab.opener = null;

        return this.calendarService.createTicket().pipe(
          map((ticket) => {
            calendarTab.location.replace(this.buildCallbackUrl(ticket));
            return resultCalendarLaunch();
          }),
          catchError((error: unknown) => {
            calendarTab.close();
            return of(resultCalendarLaunch(), this.launchFailed(error));
          })
        );
      })
    )
  );

  private buildCallbackUrl(ticket: CalendarTicket | null): string {
    if (!ticket?.code) {
      throw new Error(CALENDAR_LAUNCH_FAILED);
    }
    const callbackUrl = new URL("/auth/callback", environment.CALENDAR_ORIGIN);
    callbackUrl.searchParams.set("code", ticket.code);
    return callbackUrl.toString();
  }

  private launchFailed(error: unknown) {
    return setAPIStatus({
      apiStatus: {
        apiStatus: "error",
        apiResponseMessage:
          error instanceof HttpErrorResponse
            ? error
            : { message: CALENDAR_LAUNCH_FAILED },
      },
    });
  }
}
